import { CacheProvider }   from "@emotion/react";
import { MantineProvider } from "@mantine/core";

import { isAppleDevice }              from "_common/utils";
import {  dark, light, mantineTheme } from "_styles/theme";
/**
 * MantineThemeProvider - A theme provider component for Mantine that sets the theme type and emotion cache.
 * @typedef {Object} MantineThemeProviderProps
 * @param {Object} [emotionCache] - The cache instance for emotion.
 * @param {React.ReactNode} children - The child components to be wrapped by the theme provider.
 * @param {"dark" | "light"} [type="dark"] - The theme type, can be "dark" or "light". Default is "dark".
 */

/**
 * MantineThemeProvider - A theme provider component for Mantine that sets the theme type and emotion cache.
 *
 * @param {MantineThemeProviderProps} props - The properties object.
 *
 * @returns {React.ReactNode} The Mantine theme provider component.
 */
function MantineThemeProvider ( { emotionCache, children, type = "dark" } ) {
	const isApple = isAppleDevice ();

	const theme = mantineTheme ( {
		isApple,
		themeColorPalette : type === "dark" ? dark : light,
		isMobile          : true,
		darkMode          : true
	} );

	return (
		<MantineProvider
			withGlobalStyles
			emotionCache = { emotionCache }
			forceColorScheme = { type }
			theme = { theme }
		>
			<CacheProvider value = { emotionCache }>
				{children}
			</CacheProvider>
		</MantineProvider>
	);
}
export default MantineThemeProvider;
